import { render, staticRenderFns } from "./LearningDotsMixin.js.vue?vue&type=template&id=4eabc9a4&"
import script from "./LearningDotsMixin.js.vue?vue&type=script&lang=js&"
export * from "./LearningDotsMixin.js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports